import colors from '@rategravity/frontend/theme/colors';
import React from 'react';

export const OwnUpLogoNoBackdrop = (props) => {
  return (
    <svg {...props} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 0.120209L25.2901 7.91349C25.3012 7.92062 25.3077 7.93294 25.3077 7.94461V18.5448C25.3077 18.574 25.275 18.5915 25.2502 18.5759L13 10.8073V0.120209Z"
        stroke="none"
        fill={colors['green-dark']}
      />
      <path
        d="M13 0.120209L0.709288 7.91349C0.698838 7.92062 0.692307 7.93294 0.692307 7.94461V18.5448C0.692307 18.574 0.724963 18.5915 0.749129 18.5759L13 10.8073V0.120209Z"
        stroke="none"
        fill="#005450"
      />
      <path
        d="M16.0408 25.5048H9.9592C9.93955 25.5048 9.92308 25.4878 9.92308 25.4654V19.3897C9.92308 19.3686 9.93955 19.351 9.9592 19.351H16.0408C16.0611 19.351 16.0769 19.3686 16.0769 19.3897V25.4654C16.0769 25.4878 16.0611 25.5048 16.0408 25.5048Z"
        stroke="none"
        fill={colors['green-dark']}
      />
    </svg>
  );
};

export const PhoneIcon = (props) => (
  <svg {...props} viewBox="0 0 150 150">
    <g>
      <path d="M105.7 122.9h-66V27h8v87.9h50V35h-34v52.4h18V44.5h8v50.9h-34V27h50z" />
      <circle cx="72.7" cy="105.2" r="5" />
    </g>
  </svg>
);

export const HatIcon = (props) => (
  <svg {...props} viewBox="0 0 150 150">
    <path d="M75 27L6.4 63.3l29.5 15.6V104L75 123l39.1-19V69.8L75 90.5 51.9 78.3v9L75 99.5l31.1-16.4V99L75 114.1 43.9 99V74L23.5 63.3 75 36.1l51.5 27.2-4.4 2.3V90h8V70.4l13.5-7.1z" />
  </svg>
);

export const LinkOutIcon = (props) => (
  <svg
    {...props}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    className="link__hover--yellow"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="link__hover--yellow"
      d="M4.17168 2.60645H1V8.9498H7.34335V5.77812"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="link__hover--yellow"
      d="M8.41309 1.63086L3.92766 6.11629"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="link__hover--yellow"
      d="M9.14478 4.41553L9.14478 0.999876L5.72912 0.999876"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/shared/icons.js